import { render } from "./Regelvergleich.pug?vue&type=template&id=ea7ffdfa&lang=pug"
import script from "./Regelvergleich.js?vue&type=script&lang=js"
export * from "./Regelvergleich.js?vue&type=script&lang=js"

import "./Regelvergleich.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__